/**
 * Whether a lesson is finished, and the card surface that says so — shared
 * by the catalogue row, the home suggestions and the Arcade path; the
 * components that draw the rest of the look are in
 * components/learning/LessonDone.jsx.
 *
 * Driven by the server's `completed` (every sentence has a scored take),
 * never by `lastScore`, which one take on one sentence already sets.
 */
export function isLessonDone(lesson) {
  return lesson?.completed === true
}

/** Card surface classes: done → good tint + 1.5px good border; otherwise the plain card. */
export function lessonCardLook(done) {
  return done ? 'border-[1.5px] border-good bg-good-tint' : 'card-soft'
}
